/**
 * Created by Ninghai on 2017/12/19.
 */
export const JOB_LIST = 'JOB_LIST'
export const TEST_MUTATION = 'TEST_MUTATION'
export const ADD_COUNT = 'ADD_COUNT'
export const CHANGE_USER_STATUS = 'CHANGE_USER_STATUS'
export const SET_USER_MESSAGE = 'SET_USER_MESSAGE'

export const SET_GLOBAL_MESSAGE = 'SET_GLOBAL_MESSAGE'
export const CHANGE_LOADING_STATE = 'CHANGE_LOADING_STATE'
// enterpriseList
export const SET_NEXT_TARGET_COMPANY = 'SET_NEXT_TARGET_COMPANY'
export const CLEAN_COMPANY_LIST = 'CLEAN_COMPANY_LIST'
export const ADD_COMPANY_LIST = 'ADD_COMPANY_LIST'

// chartCollection
export const CLEAN_CHARTS_LIST = 'CLEAN_CHARTS_LIST'

// purchase target
export const SET_NEXT_PURCHASE = 'SET_NEXT_PURCHASE'

// purchase a-share target
export const SET_NEXT_ASHARE_PURCHASE = 'SET_NEXT_ASHARE_PURCHASE'

// unlisted company date
export const SET_UNLISTED_COMPANY_DATA_DATE = 'SET_UNLISTED_COMPANY_DATA_DATE'

// change  noDataLayer status
export const SET_NODATA_LAYER_STATUS = 'SET_NODATA_LAYER_STATUS'

// weChat pay count
export const SET_WECHAT_PAY_COUNT = 'SET_WECHAT_PAY_COUNT'
export const SET_WECHAT_PAY_ORDER = 'SET_WECHAT_PAY_ORDER'

// A股导航
export const SET_WHITE_LIST = 'SET_WHITE_LIST'  // 设置白名单
export const SET_DEFAULT_ACTIVE_ENTERPRISE = 'SET_DEFAULT_ACTIVE_ENTERPRISE'  // 设置默认激活的企业
export const SET_STRCTURE_MATRIX = 'SET_STRCTURE_MATRIX'

// 设置api激活链接
export const SET_API_ACTIVE_LINK = 'SET_API_ACTIVE_LINK'

// loading动画
export const SET_LOADING_ANIMATION_STATUS = 'SET_LOADING_ANIMATION_STATUS'

// echarts
export const ADD_CHART = 'ADD_CHART'
export const REMOVE_CHART = 'REMOVE_CHART'
export const CLEAR_CHART = 'CLEAR_CHART'

export const CHANGE_INDEX = 'CHANGE_INDEX'

/** 
 * 情绪指数部分
*/
export const FACTOR_TYPE = 'FACTOR_TYPE'//因子类型
export const EMOTION_DETAILS = 'EMOTION_DETAILS'//各个维度的详情
export const STOCK_DETAILS = 'STOCK_DETAILS'//情绪指数右侧因子走势（折线图）
export const LEFT_LOADING = 'LEFT_LOADING'//改变左侧loading
export const RIGHT_LOADING = 'RIGHT_LOADING'//改变右侧loading

/** 
 * 电商标准化部分
*/
export const RETAILERS = 'RETAILERS'
export const RETAILERS_TOP = 'RETAILERS_TOP'
export const SHOW_REPORT = 'SHOW_REPORT'
export const DATE_TYPE = 'DATE_TYPE'

/**
 * 直播标准化
 */
export const DATE_TYPE_LIVE = 'DATE_TYPE_LIVE'
export const LIVE_DATA = 'LIVE_DATA'

//品牌馆
export const BRAND_DATA = 'BRAND_DATA'

//15万天猫
// export const TMALL_DATA = 'TMALL_DATA'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js